import { render } from "./I_Window.vue?vue&type=template&id=4eef42cf"
import script from "./I_Window.vue?vue&type=script&lang=js"
export * from "./I_Window.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__